import * as t from 'ts-schema';
import { defineMessage } from 'magpie-lib/models';
const show = defineMessage({
  type: 'papercuts-show'
});
const hide = defineMessage({
  type: 'papercuts-hide'
});
const reposition = defineMessage({
  type: 'papercuts-reposition',
  payloadSchema: t.object({
    bottomOffset: t.optional(t.number),
    rightOffset: t.optional(t.number)
  })
});
export const papercutsControls = {
  show,
  hide,
  reposition
};